import { render, staticRenderFns } from "./MajorShoppingInfoHistory.vue?vue&type=template&id=f9204e74&scoped=true"
import script from "./MajorShoppingInfoHistory.vue?vue&type=script&lang=ts"
export * from "./MajorShoppingInfoHistory.vue?vue&type=script&lang=ts"
import style0 from "./MajorShoppingInfoHistory.vue?vue&type=style&index=0&id=f9204e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9204e74",
  null
  
)

export default component.exports